import React, { useState } from 'react';
import { get, last } from 'lodash';
import moment from 'moment';
import { object, func, string, array, bool} from 'prop-types';
import { withApollo } from 'react-apollo';
import { Divider, notification } from 'antd';
import { Row, Column, Text, ConfirmFooterButtons, Icon, IconContainer } from '../../common';
import { _get  } from '../../../utils/misc';
import SEND_NOTIFICATION from '../../../queries/SEND_NOTIFICATION';

const styleNotification = {
    borderRadius: 8,
    height: 42,
    padding: '9px 12px',
    top: 15
};

const showNotification = (isSuccess) => {
    const error = {
        msg: 'Hubo un error al desbloquear la puerta.',
        color: '#BD2C00',
        icon: 'alert-circle',
        bgColor: '#F7E6E1',
        borderColor: '#BD2C00'
    };
    const success = {
        msg: 'Puerta desbloqueada correctamente.',
        color: '#22A889',
        icon: 'checkmark-circle',
        bgColor: '#E6F5F1',
        borderColor: '#B6DFD6'
    };
    const { msg, bgColor, icon, color, borderColor } = isSuccess ? success : error;
    notification.open({
        message: (
            <Row align='center'>
                <Icon name={icon} size={24} color={color} />
                <Divider type='vertical' style={{ background: color, height: '1.5em', margin: '0px 16px 0px 14px' }} />
                <Text text={msg} size={12} color='#323A44' />
            </Row>
        ),
        style: { ...styleNotification, backgroundColor: bgColor, border: `1px solid ${borderColor}` }
    });
};



const OrderQr= ({ dataQr, id, storeName, isErrorQr, onClose, client, isBipicking, relatedOrderId, onUnlocked, ...props }) => {
    const email = get(last(dataQr), 'shopper');
    const [loading, setLoading] = useState(false);
    const [disabledButton, setDisabledButton] = useState(false);


    const sendNotification = (orderId) => client.mutate({
        mutation: SEND_NOTIFICATION,
        variables: { 
            input: {  
                email: email,
                notificationType: 34,
                title: 'Puerta Embolsado Desbloqueada',
                message: 'Embolsado Habilitado',
                orderId
            }
        }
    });

    const onAcceptRequest = async () => {
        setLoading(true);
        setDisabledButton(true);

        const notifications = [sendNotification(id)];
        if (isBipicking && relatedOrderId) {
            notifications.push(sendNotification(relatedOrderId));
        }

        Promise.all(notifications)
        .then(() => {
            showNotification(true);
            setLoading(false);
            setDisabledButton(true);
            if (onUnlocked) onUnlocked();
            setTimeout(() => onClose(), 1000);
        }).catch((error) => {
            console.error(error);
            showNotification(false);
            setDisabledButton(false);
            setLoading(false);
        });
    };

    const formatDate = (dateString) => {
        if (!dateString || !moment(dateString).isValid()) return "-";
        return moment(dateString).format('DD/MM/YYYY HH:mm');
    };

    return (
        <div style={{ width: '100%', maxHeight: 'calc(100% - 120px)', overflowY: 'auto' }}>
            <Row style={{ border: '1px solid #eaeaea', borderRadius: 15, padding: 13, backgroundColor: "#fbfbfb" }}>
                <Row>
                    <Column  width={120} >
                        <Row align='center' mB={5} mR={10} gap={5}>
                            <Text text={`Motivo:`} size={15} strong />
                            <Text text={get(last(dataQr), 'actionDescription', '-')} size={15} strong />
                        </Row>
                        <Row style={{ marginTop: 5 }}>
                            <table style={{ width: '100%' }}>
                                <tbody>
                                    <tr>
                                        <td><Text text='Sala' semibold /></td>
                                        <td><Text text={storeName} /></td>
                                    </tr>
                                    <tr>
                                        <td><Text text='Shopper' semibold /></td>
                                        <td><Text text={get(last(dataQr), 'shopper')} /></td>
                                    </tr>
                                    <tr>
                                        <td><Text text='Fecha de generación' semibold /></td>
                                        <td><Text text={formatDate(get(last(dataQr), 'date'))} /></td>
                                    </tr>
                                    <tr>
                                        <td><Text text='Fecha de escaneo' semibold /></td>
                                        <td><Text text={formatDate(get(last(dataQr), 'updateDate'))} /></td>
                                    </tr>
                                    <tr>
                                        <td><Text text='QR paso por puerta' semibold /></td>
                                        <td><Text text={isErrorQr ? 'No' : 'Si'} /></td>
                                    </tr>
                                    {isBipicking && (
                                        <>
                                            <tr>
                                                <td colSpan={2}>
                                                    <div style={{ borderTop: '1px solid #eaeaea', margin: '8px 0' }} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><Text text='Orden actual' semibold /></td>
                                                <td><Text text={id} strong /></td>
                                            </tr>
                                            <tr>
                                                <td><Text text='Emparejada con:' semibold /></td>
                                                <td><Text text={relatedOrderId} strong /></td>
                                            </tr>
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </Row>
                    </Column>
                </Row>
            </Row>
            {isErrorQr && isBipicking && (
                <Row align='center' style={{ padding: '12px 2px', gap: 8 }}>
                    <IconContainer size={19}><Icon name='circle-exclam' size={20} color='#5B5EA6' /></IconContainer>
                    <Text text='Esta acción desbloquea la puerta para las 2 ordenes' size={13} color='#323A44' />
                </Row>
            )}
            {isErrorQr && <ConfirmFooterButtons  confirmDisabled={disabledButton} confirmLabel='Desbloquear'  onCancel={onClose} onConfirm={onAcceptRequest} loading={loading} /> }
        </div>
    );
};

OrderQr.propTypes = {
    dataQr: array,
    id: string,
    storeName: string,
    client: object,
    isErrorQr: bool,
    onClose: func,
    isBipicking: bool,
    relatedOrderId: string,
    onUnlocked: func,
};

OrderQr.defaultProps = {
    onClose: () => {},
    isErrorQr: false,
    isBipicking: false,
    relatedOrderId: null,
};

export default withApollo(OrderQr);
